import { render, staticRenderFns } from "./catalogos.vue?vue&type=template&id=990d9c38&"
import script from "./catalogos.vue?vue&type=script&lang=js&"
export * from "./catalogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports